<template>
    <div>
        <ob-modal2 id="activityLogPrint" :show.sync="show" width="960px" :backdrop="false" backGroundColor="#f8f8f8">
            <template slot="modal-title">
                I-539 - Activity View
            </template>
            <template slot="modal-body">
                <template v-if="showLoader">
                    <ob-spinner></ob-spinner>
                </template>
                <div v-else>
                    <div class="col-md-12 top-div-class " v-for="(H1blogDetail,logIndex) in geth1bdetails" :key="logIndex">
                        <div class="date-time-style">
                            <p style="text-align: left;color:#000;font-size:14px">{{H1blogDetail.activityLogDateTime.date | formatDate('DD')}} {{getMonthName(H1blogDetail.activityLogDateTime.date)}}'{{H1blogDetail.activityLogDateTime.date | formatDate('YY')}} </p>
                            <p style="font-weight: 600;font-size: 12px;color:rgb(139, 139, 139)">at {{H1blogDetail.activityLogDateTime.date | formatDate('hh:mm A') }}</p>
                            <!-- <p style="font-weight: 600;font-size: 12px;color:#363434">{{H1blogDetail.CreatedDateTime | formatDate('hh:mm A') }}</p> -->
                            <!-- <p >{{H1blogDetail.CreatedDateTime | formatDate('MM/DD/YYYY')}}</p> -->
                        </div>
                         <!-- :class="geth1bdetails.length - 1 == logIndex ? 'HideUiCss' : 'timeline'" -->
                        <ul :class="geth1bdetails.length - 1 == logIndex ? 'HideUiCss' : 'timeline'">
                            <!-- <li :class="{'update-img': (H1blogDetail.actions == 'Update' || H1blogDetail.ActivityType == 'H1BPacketEdited' || H1blogDetail.ActivityType == 'H1BWithdrawnUpdated'),'withdrawal-img': (H1blogDetail.ActivityType == 'H1BWithdrawn'),'folder-img': (H1blogDetail.ActivityType == 'InitiateNewH1B'),'upload-img': (H1blogDetail.ActivityType == 'Upload') ,'share-img': (H1blogDetail.ActivityType == 'Share') ,'delete-img': (H1blogDetail.ActivityType == 'Delete') ,'saved-img': (H1blogDetail.ActivityType == 'Save') ,'download-img': (H1blogDetail.ActivityType == 'Download'),
                            'request-img': (H1blogDetail.ActivityType == 'PetitionDocsRequested'),'approved-img': (H1blogDetail.ActivityType == 'ApprovedPetitionDocs'),'rejected-img': (H1blogDetail.ActivityType == 'RejectedPetitionDocs'),'submitandresubmit-img': (H1blogDetail.ActivityType == 'SubmittedPetitionDocs' || H1blogDetail.ActivityType == 'ResubmittedPetitionDocs'),
                            'resendmailandpetition-img': (H1blogDetail.ActivityType == 'ResendMailToReviewer' || H1blogDetail.ActivityType == 'ResendPetitionDocsRequest'),'canceled-img': (H1blogDetail.ActivityType == 'CancelledPetitionDocs')}"> -->
                             <li :class="{'folder-img': (H1blogDetail.actions == 'Create'),'update-img': (H1blogDetail.actions == 'Update')}">

                                <div class="col-md-12 white-BgColor" :style="[H1blogDetail.logs == null || H1blogDetail.logs == ''  ? {'height' : 'none !important'} : {'height' : 'auto'}]">
                                    <div>
                                        <h4 class="heading mL0" style="margin-top: 10px" v-html="updateHyperLink(H1blogDetail.activityLogMessage)"></h4>
                                        <div v-if="H1blogDetail.activityLogMessage.includes('requested to Re-send the Form I-539')"> 
                                            <div class='col-md-12 metadatapadding comments-style'>
                                                <label>Comments</label>
                                                <p class="excess-header" style="color:#253A69;word-break: break-word;" >{{H1blogDetail.metaInformation.Comments}}</p>
                                            </div>
                                        </div>
                                       <div v-for="(H1bData, vIndex) in H1blogDetail.logs" :key="vIndex">
                                            <div v-if="H1blogDetail.activityLogMessage.includes('uploaded the Approval Notice')"> 
                                               <div class='col-md-3 metadatapadding' v-if="H1bData.accessPath == 'FormI539.OtherDocuments.Number'">
                                                    <label>Receipt Number</label>
                                                    <p class="excess-header" style="color:#253A69;word-break: break-word;" >{{H1bData.newValue}}</p>
                                               </div>
                                               <div class='col-md-3 metadatapadding' v-else-if="H1bData.accessPath == 'FormI539.OtherDocuments.StartDate'">
                                                    <label>I-797A Start Date</label>
                                                        <p class="excess-header" style="color:#253A69;word-break: break-word;" >{{H1bData.newValue}}</p>
                                               </div>
                                                 <div class='col-md-3 metadatapadding' v-else-if="H1bData.accessPath == 'FormI539.OtherDocuments.ExpirationDate.Date'">
                                                    <label>I-797A End Date</label>
                                                     <p class="excess-header" style="color:#253A69;word-break: break-word;" >{{H1bData.newValue | formatDate('MM/DD/YYYY')}}</p>
                                               </div>
                                                <div class='col-md-3 metadatapadding' v-else-if="H1bData.accessPath == 'FormI539.OtherDocuments.I94StartDate'">
                                                    <label>I-94 Start Date</label>
                                                     <p class="excess-header" style="color:#253A69;word-break: break-word;" >{{H1bData.newValue | formatDate('MM/DD/YYYY')}}</p>
                                               </div>
                                                <div class='col-md-3 metadatapadding' v-else-if="H1bData.accessPath == 'FormI539.OtherDocuments.I94EndDate'">
                                                    <label>I-94 End Date</label>
                                                     <p class="excess-header" style="color:#253A69;word-break: break-word;" >{{H1bData.newValue | formatDate('MM/DD/YYYY')}}</p>
                                               </div>
                                               <div class='col-md-3 metadatapadding' v-else-if="H1bData.accessPath == 'FormI539.OtherDocuments.I94Number'">
                                                    <label>I-94 Number</label>
                                                     <p class="excess-header" style="color:#253A69;word-break: break-word;" >{{H1bData.newValue}}</p>
                                               </div>
                                               </div>
                                               <div v-if="H1blogDetail.activityLogMessage.includes('updated the Approval Notice')"> 
                                               <div class='col-md-3 metadatapadding' v-if="H1bData.accessPath == 'FormI539.OtherDocuments.Number'">
                                                    <label>Receipt Number</label>
                                                    <p class="excess-header" style="color:#253A69;word-break: break-word;" >{{H1bData.newValue}}</p>
                                               </div>
                                               <div class='col-md-3 metadatapadding' v-else-if="H1bData.accessPath == 'FormI539.OtherDocuments.StartDate'">
                                                    <label>I-797A Start Date</label>
                                                        <p class="excess-header" style="color:#253A69;word-break: break-word;" >{{H1bData.newValue}}</p>
                                               </div>
                                                 <div class='col-md-3 metadatapadding' v-else-if="H1bData.accessPath == 'FormI539.OtherDocuments.ExpirationDate.Date'">
                                                    <label>I-797A End Date</label>
                                                     <p class="excess-header" style="color:#253A69;word-break: break-word;" >{{H1bData.newValue | formatDate('MM/DD/YYYY')}}</p>
                                               </div>
                                                <div class='col-md-3 metadatapadding' v-else-if="H1bData.accessPath == 'FormI539.OtherDocuments.I94StartDate'">
                                                    <label>I-94 Start Date</label>
                                                     <p class="excess-header" style="color:#253A69;word-break: break-word;" >{{H1bData.newValue | formatDate('MM/DD/YYYY')}}</p>
                                               </div>
                                                <div class='col-md-3 metadatapadding' v-else-if="H1bData.accessPath == 'FormI539.OtherDocuments.I94EndDate'">
                                                    <label>I-94 End Date</label>
                                                     <p class="excess-header" style="color:#253A69;word-break: break-word;" >{{H1bData.newValue | formatDate('MM/DD/YYYY')}}</p>
                                               </div>
                                               <div class='col-md-3 metadatapadding' v-else-if="H1bData.accessPath == 'FormI539.OtherDocuments.I94Number'">
                                                    <label>I-94 Number</label>
                                                     <p class="excess-header" style="color:#253A69;word-break: break-word;" >{{H1bData.newValue}}</p>
                                               </div>
                                               </div>
                                               <div v-else-if="H1blogDetail.activityLogMessage.includes('uploaded the Receipt Notice')"> 
                                               <div class='col-md-3 metadatapadding' v-if="H1bData.accessPath == 'FormI539.OtherDocuments.Number'">
                                                    <label>Receipt Number</label>
                                                     <p class="excess-header" style="color:#253A69;word-break: break-word;" >{{H1bData.newValue}}</p>
                                               </div>
                                               <div class='col-md-3 metadatapadding' v-else-if="H1bData.accessPath == 'FormI539.OtherDocuments.StartDate'">
                                                    <label>Receipt Date</label>
                                                     <p class="excess-header" style="color:#253A69;word-break: break-word;" >{{H1bData.newValue}}</p>
                                               </div>
                                               <div class='col-md-3 metadatapadding' v-else-if="H1bData.accessPath == 'FormI539.OtherDocuments.ExpirationDate.Date'">
                                                    <label>Notice Date</label>
                                                     <p class="excess-header" style="color:#253A69;word-break: break-word;" >{{H1bData.newValue | formatDate('MM/DD/YYYY')}}</p>
                                               </div>
                                               </div>
                                               <div v-else-if="H1blogDetail.activityLogMessage.includes('updated the Receipt Notice')"> 
                                               <div class='col-md-3 metadatapadding' v-if="H1bData.accessPath == 'FormI539.OtherDocuments.Number'">
                                                    <label>Receipt Number</label>
                                                     <p class="excess-header" style="color:#253A69;word-break: break-word;" >{{H1bData.newValue}}</p>
                                               </div>
                                               <div class='col-md-3 metadatapadding' v-else-if="H1bData.accessPath == 'FormI539.OtherDocuments.StartDate'">
                                                    <label>Receipt Date</label>
                                                     <p class="excess-header" style="color:#253A69;word-break: break-word;" >{{H1bData.newValue}}</p>
                                               </div>
                                               <div class='col-md-3 metadatapadding' v-else-if="H1bData.accessPath == 'FormI539.OtherDocuments.ExpirationDate.Date'">
                                                    <label>Notice Date</label>
                                                     <p class="excess-header" style="color:#253A69;word-break: break-word;" >{{H1bData.newValue | formatDate('MM/DD/YYYY')}}</p>
                                               </div>
                                               </div>
                                               <div v-else-if="H1blogDetail.activityLogMessage.includes('uploaded the Denied Notice') || H1blogDetail.activityLogMessage.includes('updated the Denied Notice')"> 
                                               <div class='col-md-3 metadatapadding' v-if="H1bData.accessPath == 'FormI539.OtherDocuments.PetitionDate'">
                                                    <label>Notice Date</label>
                                                     <p class="excess-header" style="color:#253A69;word-break: break-word;" >{{H1bData.newValue | formatDate('MM/DD/YYYY')}}</p>
                                               </div>
                                               <div class='col-md-3 metadatapadding' v-else-if="H1bData.accessPath == 'FormI539.OtherDocuments.ExpirationDate.Date'">
                                                    <label>Termination Date</label>
                                                     <p class="excess-header" style="color:#253A69;word-break: break-word;" >{{H1bData.newValue | formatDate('MM/DD/YYYY')}}</p>
                                               </div>
                                               <div class='col-md-12 metadatapadding comments-style' v-else-if="H1bData.accessPath == 'FormI539.OtherDocuments.Comments'">
                                                    <label>Comments</label>
                                                     <p class="excess-header" style="color:#253A69;word-break: break-word;" >{{H1bData.newValue}}</p>
                                               </div>
                                               <div class='col-md-12 metadatapadding comments-style' v-else-if="H1bData.accessPath == 'FormI539.OtherDocuments.Notes'">
                                                    <label>Notes</label>
                                                     <p class="excess-header" style="color:#253A69;word-break: break-word;" >{{H1bData.newValue}}</p>
                                               </div>
                                               </div>
                                        <!-- </div> -->
                                        </div>
                                        <!-- <div :class="{'col-md-3 metadatapadding': (H1bData.Name != 'Comments'  && H1bData.Name != 'Reasons' &&  H1bData.Name != 'Reason' &&  H1bData.Name != 'Reasons for Rejection' && H1bData.Name != 'Notes' && H1bData.Name != 'Note') , 'col-md-12 metadatapadding': (H1bData.Name == 'Comments'  || H1bData.Name == 'Reasons' || H1bData.Name == 'Reasons for Rejection' || H1bData.Name == 'Reason' || H1bData.Name == 'Notes' || H1bData.Name == 'Note')}"  v-for="(H1bData, vIndex) in H1blogDetail.UpdateData" :key="vIndex">
                                           <template v-if="H1bData.Name == 'Reasons for Rejection' || H1bData.Name == 'Reasons'">
                                                <label>{{H1bData.Name}} </label>
                                                <div class="reject-text-style" v-html="H1bData.Value" style="color:rgb(77, 77, 77)"></div>
                                            </template>
                                             <template v-else-if="H1bData.Name == 'Employee Email'">
                                                 <label>{{H1bData.Name}} </label>
                                                <p class="excess-header" style="color:#253A69;word-break: break-word;" :title="H1bData.Value">{{H1bData.Value}}</p>
                                            </template>
                                            <template v-else-if="H1bData.Name != 'Comments'">
                                                <label>{{H1bData.Name}} </label>
                                                <p style="color:#253A69;word-break: break-word;">{{H1bData.Value}}</p>
                                            </template>
                                            
                                            <template v-else>
                                                <p class="comments-style" style="color:rgb(77, 77, 77)">{{H1bData.Value}}</p>
                                            </template>
                                        </div> -->

                                    </div>
                                </div>

                            </li>
                        </ul>

                    </div>
                </div>

            </template>
            
            <template slot="modal-footer" >
                <div id="modalFooter">
                <ob-button type="secondary" @click="show=false">Cancel</ob-button>
                <ob-button @click="printOptions">Print</ob-button>
                </div>
            </template>
        </ob-modal2>
    </div>
</template>

<script>
    export default {
        props: ['openActivityLog', 'FormI539Id','h1bStatus'],
        data() {
            return {
                show: false,
                geth1bdetails: [],
                showLoader:false

            }
        },

        watch: {
            openActivityLog(val) {
                    this.show = val
                },
                show(val) {
                       this.$emit('update:openActivityLog', val)
                    if (val == true) {
                        this.h1bActivities();
                    } else {
                        this.resetvalues()
                    }
                }
        },
        created() {
            this.show = this.openActivityLog
        },
        computed:{
            getLiClassName(){
                return 'event'
            }
        },
        methods: {
            updateHyperLink(description) {
                if (description && description != "") {
                    return description.replace(/<a/g, '<a  style="pointer-events:none;color: #337ab7"');
                }
                return description;
            },
            h1bActivities() {
                    this.showLoader = true
                    var FormI539Id = this.FormI539Id;
                    ajax.post(`FormI539/${FormI539Id}/Activity?pageSize=0`, {}, res => {
                        if (res.status == 200) {
                            this.geth1bdetails = res.data.data;
                           // //Console.log("h1b", this.geth1bdetails)
                           this.showLoader = false
                        }else{
                            this.showLoader = false
                        }
                    },{},'FormI539')
                },
                // formatAMPM(date) {
                //     
                //         var hours = moment(date).format("hh");
                //         var minutes = moment(date).format("mm");
                //         var ampm = hours >= 12 ? 'PM' : 'AM';
                //         hours = hours % 12;
                //         hours = hours ? hours : 12; // the hour '0' should be '12'
                //         minutes = minutes < 10 ? '0'+minutes : minutes;
                //         var strTime = hours + ':' + minutes + ' ' + ampm;
                //         return strTime;
                //  },
                 getMonthName(date){
                     
                      var monthVal = moment(date).format("MM");
                    var formattedMonth = moment(monthVal, 'MM').format('MMM'); 
                    return formattedMonth
                 },
                resetvalues() {

                },
                 printOptions() {
                //this.$loading({ 'loadingText': 'Loading...' })
                
                var w = window.open();
                var printOne = $('#activityLogPrint').html();
               
               w.document.write('<html><head>  </head><style> body{ font-family: "Open Sans", sans-serif } .metadatapadding{ padding: 0 0 5px 15px;display:inline-block;} .name-hyperlink{color: #337ab7} #modalFooter { display: none } .white-BgColor { background-color:#FFF } @media print {  #modalFooter { display: none } } .heading { color: #000; font-size: 15px; font-weight: 700; margin-left: 15px; } .sub-heading { font-size: 14px; margin-left: 10px; color: #090a0c; font-weight: 600; } label { font-size: 12px;  margin-top: 10px; } p { font-weight: bold; font-size: 12px; } ul{ margin-bottom: -2px } ul.timeline { position: relative; display: inline-block; width:80%; margin-bottom:0; float:none; padding: 0px 0px 0 50px; list-style: none; vertical-align: top;} ul.HideUiCss { position: relative; display: inline-block; width:80%; margin-bottom:0; float:none; padding: 0px 0px 0 50px; list-style: none; vertical-align: top;}  ul.timeline:before{ background: #5788FA; display: inline-block; position: absolute; content: attr(data-date); left: 26px; width: 3px; height: 100%; top: 33px; z-index: 400;} ul.HideUiCss:before { background: #5788FA; display: inline-block; position: absolute; content: attr(data-date); left: 26px; width: 2px; height: 10%; z-index: 400; } ul.timeline > li.upload-img:before { background: url("'+c.CDNIMAGESBASEURL+'/ess/ESSApp/static/Images/ic_upload.svg") no-repeat; content: attr(data-date); display: inline-block; position: absolute; border-radius: 50%; /* border: 2px solid #346CED; */ left: 15px; width: 30px; height: 30px; z-index: 400; } ul.timeline > li.update-img:before { background: url("'+c.CDNIMAGESBASEURL+'/ess/ESSApp/static/Images/ic_update.svg") no-repeat; content: attr(data-date); display: inline-block; position: absolute; border-radius: 50%; /* border: 2px solid #346CED; */ left: 15px; width: 30px; height: 30px; z-index: 400; } ul.timeline > li.withdrawal-img:before { background: url("'+c.CDNIMAGESBASEURL+'/hrspa/Content/Images/Withdraw.svg") no-repeat; content: attr(data-date); display: inline-block; position: absolute; border-radius: 50%; left: 5px; width: 30px; height: 30px; z-index: 400;} ul.timeline > li.folder-img:before { background: url("'+c.CDNIMAGESBASEURL+'/ess/ESSApp/static/Images/ic_folder.svg") no-repeat; content: attr(data-date); display: inline-block; position: absolute; border-radius: 50%; /* border: 2px solid #346CED; */ left: 15px; width: 30px; height: 30px; z-index: 400; } ul.timeline > li.request-img:before{background:url("'+c.CDNIMAGESBASEURL+'/hrspa/Content/Images/ic_requested.svg") no-repeat;content:attr(data-date);display:inline-block;position:absolute;border-radius:50%;left:15px;width:30px;height:30px;z-index:400;} ul.timeline > li.approved-img:before{background:url("'+c.CDNIMAGESBASEURL+'/hrspa/Content/Images/ic_approved.svg") no-repeat;content:attr(data-date);display:inline-block;position:absolute;border-radius:50%;left:15px;width:30px;height:30px;z-index:400;} ul.timeline > li.rejected-img:before{background:url("'+c.CDNIMAGESBASEURL+'/hrspa/Content/Images/ic_rejected.svg") no-repeat;content:attr(data-date);display:inline-block;position:absolute;border-radius:50%;left:15px;width:30px;height:30px;z-index:400;} ul.timeline > li.submitandresubmit-img:before{background:url("'+c.CDNIMAGESBASEURL+'/hrspa/Content/Images/ic_submitnresubmit.svg") no-repeat;content:attr(data-date);display:inline-block;position:absolute;border-radius:50%;left:15px;width:30px;height:30px;z-index:400;} ul.timeline > li.resendmailandpetition-img:before{background:url("'+c.CDNIMAGESBASEURL+'/hrspa/Content/Images/resend_email&resend_petition.svg") no-repeat;content:attr(data-date);display:inline-block;position:absolute;border-radius:50%;left:15px;width:30px;height:30px;z-index:400;} ul.timeline > li.canceled-img:before{background:url("'+c.CDNIMAGESBASEURL+'/hrspa/Content/Images/ic_canceledrequest.svg") no-repeat;content:attr(data-date);display:inline-block;position:absolute;border-radius:50%;left:15px;width:30px;height:30px;z-index:400;} ul.timeline > li.share-img:before { background: url("'+c.CDNIMAGESBASEURL+'/hrspa/Content/Images/ic_share.svg") no-repeat; content: attr(data-date); display: inline-block; position: absolute; border-radius: 50%; /* border: 2px solid #346CED; */ left: 15px; width: 30px; height: 30px; z-index: 400; } ul.timeline > li.delete-img:before { background: url("'+c.CDNIMAGESBASEURL+'/hrspa/Content/Images/activity_delete_icon.svg") no-repeat; content: attr(data-date); display: inline-block; position: absolute; border-radius: 50%; /* border: 2px solid #346CED; */ left: 15px; width: 30px; height: 30px; z-index: 400; } ul.timeline > li.saved-img:before { background: url("'+c.CDNIMAGESBASEURL+'/hrspa/Content/Images/ic_saved.svg") no-repeat; content: attr(data-date); display: inline-block; position: absolute; border-radius: 50%; /* border: 2px solid #346CED; */ left: 15px; width: 30px; height: 30px; z-index: 400; } ul.timeline > li.download-img:before { background: url("'+c.CDNIMAGESBASEURL+'/hrspa/Content/Images/activity_download_icon.svg") no-repeat; content: attr(data-date); display: inline-block; position: absolute; border-radius: 50%; /* border: 2px solid #346CED; */ left: 15px; width: 30px; height: 30px; z-index: 400; } ul.HideUiCss > li.upload-img:before { background: url("'+c.CDNIMAGESBASEURL+'/ess/ESSApp/static/Images/ic_upload.svg") no-repeat; content: attr(data-date); display: inline-block; position: absolute; border-radius: 50%; /* border: 2px solid #346CED; */ left: 15px; width: 30px; height: 30px; z-index: 400; } ul.HideUiCss > li.update-img:before { background: url("'+c.CDNIMAGESBASEURL+'/ess/ESSApp/static/Images/ic_update.svg") no-repeat; content: attr(data-date); display: inline-block; position: absolute; border-radius: 50%; /* border: 2px solid #346CED; */ left: 15px; width: 30px; height: 30px; z-index: 400; } ul.HideUiCss > li.withdrawal-img:before { background: url("'+c.CDNIMAGESBASEURL+'/hrspa/Content/Images/Withdraw.svg") no-repeat; content: attr(data-date); display: inline-block; position: absolute; border-radius: 50%; left: 5px; width: 30px; height: 30px; z-index: 400; } ul.HideUiCss > li.folder-img:before { background: url("'+c.CDNIMAGESBASEURL+'/ess/ESSApp/static/Images/ic_folder.svg") no-repeat; content: attr(data-date); display: inline-block; position: absolute; border-radius: 50%; /* border: 2px solid #346CED; */ left: 15px; width: 30px; height: 30px; z-index: 400; } ul.HideUiCss > li.share-img:before { background: url("'+c.CDNIMAGESBASEURL+'/hrspa/Content/Images/ic_share.svg") no-repeat; content: attr(data-date); display: inline-block; position: absolute; border-radius: 50%; /* border: 2px solid #346CED; */ left: 15px; width: 30px; height: 30px; z-index: 400; } ul.HideUiCss > li.delete-img:before { background: url("'+c.CDNIMAGESBASEURL+'/hrspa/Content/Images/activity_delete_icon.svg") no-repeat; content: attr(data-date); display: inline-block; position: absolute; border-radius: 50%; /* border: 2px solid #346CED; */ left: 15px; width: 30px; height: 30px; z-index: 400; } ul.HideUiCss > li.saved-img:before { background: url("'+c.CDNIMAGESBASEURL+'/hrspa/Content/Images/ic_saved.svg") no-repeat; content: attr(data-date); display: inline-block; position: absolute; border-radius: 50%; /* border: 2px solid #346CED; */ left: 15px; width: 30px; height: 30px; z-index: 400; } ul.HideUiCss > li.download-img:before { background: url("'+c.CDNIMAGESBASEURL+'/hrspa/Content/Images/activity_download_icon.svg") no-repeat; content: attr(data-date); display: inline-block; position: absolute; border-radius: 50%; /* border: 2px solid #346CED; */ left: 15px; width: 30px; height: 30px; z-index: 400; } .upload-img ,.update-img, .withdrawal-img, .folder-img ,.share-img ,.delete-img, .saved-img, .download-img { padding-bottom: 0px; } .modal-background{ background: rgb(248, 248, 248) !important }.reject-text-style{font-style:italic; word-break:break-word;} .comments-style{ background-color: #f3f3f3; margin-top: 10px; border-radius: 5px; padding: 10px; font-style: italic; word-break: break-word; } .top-div-class{ margin-bottom:0px } .date-time-style{ float: none; width: 100px; display: inline-block; padding-bottom: 0px; vertical-align: top; } .modal-body { position: relative; padding: 15px; display: inline-block; width: 100%} </style> <body>' + printOne + '</body></html>');

                setTimeout(() => {
                    w.window.print();
                    w.document.close();
                    //this.$loading({}).close()
                }, 100)


                // const modal = document.getElementById("activityLogPrint")
                // const cloned = modal.cloneNode(true)
                // let section = document.getElementById("print")

                // if (!section) {
                //     section  = document.createElement("div")
                //     section.id = "print"
                //     document.body.appendChild(section)
                // }

                // section.innerHTML = "";
                // section.appendChild(cloned);
                // window.print();



            },

               
        }
    }
</script>
<style lang="scss" scoped>
@import './../../../../static/Css/Content/SCSS/post-login-scss/scss/cdnVariables';
    .white-BgColor {
        background-color:#FFF;
            padding-bottom: 10px
    }
    .heading {
        color: #000;
        font-size: 14px;
        font-weight: 700;
        margin-left: 15px;
       // text-transform: capitalize;
    }
    
    .sub-heading {
        font-size: 14px;
        margin-left: 10px;
        color: #090a0c;
        font-weight: 600;
    }
    
    label {
        font-size: 12px;
        //font-weight: 100;
        margin-top: 10px;
    }
    
    p {
        font-weight: bold;
        font-size: 12px;
    }
    ul{
        margin-bottom:15px
    }
    ul.timeline {
        //list-style-type: none;
        position: relative;
        // padding: 0px 50px;
        display: inline-block;
        // width:90%;
        margin-bottom:0;
        float:none;
        padding: 0px 0px 0 50px;
    width: calc(100% - 110px);
    list-style: none;
    vertical-align: top;
    }
    ul.HideUiCss {
        //list-style-type: none;
        // position: relative;
        // padding: 0px 50px;
        // display: inline-block;
        // width:90%

        position: relative;
        // padding: 0px 50px;
        display: inline-block;
        // width:90%;
        margin-bottom:0;
        float:none;
        padding: 0px 0px 0 50px;
    width: calc(100% - 110px);
    list-style: none;
    vertical-align: top;
    }
  @media screen {
    #print {
        display: none;
    }
    }

    @media print {
    body * {
    visibility:hidden;
    }
    #print, #print * {
        visibility:visible;
    }
    #print {
        position:absolute;
        left:0;
        top:0;
    }
    }
    
    ul.timeline:before {
        // background: #5788FA;
        // display: inline-block;
        // position: absolute;
        // content: attr(data-date);
        // left: 28px;
        // width: 2px;
        // height: 130%;
        // z-index: 400;

                background: #5788FA;
    display: inline-block;
    position: absolute;
    content: attr(data-date);
    left: 17px;
    width: 3px;
    height: 100%;
    top: 25px;
    z-index: 400;
    }
      ul.HideUiCss:before {
        background: #5788FA;
        display: inline-block;
        position: absolute;
        content: attr(data-date);
        left: 16px;
        width: 3px;
        height: 10%;
        z-index: 400;
    }
    
    ul.timeline > li.upload-img:before {
    //     background: url('#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_upload.svg') no-repeat;
      
    //     content: attr(data-date);
    //     display: inline-block;
    //     position: absolute;
    //     border-radius: 50%;
    //    /* border: 2px solid #346CED; */
    //     left: 15px;
    //     width: 30px;
    //     height: 30px;
    //     z-index: 400;

            background: url('#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_upload.svg') no-repeat;
    content: attr(data-date);
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    /* border: 2px solid #346CED; */
    left: 5px;
    width: 30px;
    height: 30px;
    z-index: 400;
    }
    ul.timeline > li.update-img:before {
    //     background: url('#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_update.svg') no-repeat;
      
    //     content: attr(data-date);
    //     display: inline-block;
    //     position: absolute;
    //     border-radius: 50%;
    //    /* border: 2px solid #346CED; */
    //     left: 15px;
    //     width: 30px;
    //     height: 30px;
    //     z-index: 400;
        
            background: url('#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_update.svg') no-repeat;
    content: attr(data-date);
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    /* border: 2px solid #346CED; */
    left: 5px;
    width: 30px;
    height: 30px;
    z-index: 400;
    }
    ul.timeline > li.withdrawal-img:before {
        background: url('#{$CDNIMAGESBASEURL}/hrspa/Content/Images/Withdraw.svg') no-repeat;
        content: attr(data-date);
        display: inline-block;
        position: absolute;
        border-radius: 50%;
        left: 5px;
        width: 30px;
        height: 30px;
        z-index: 400;
    }
    ul.timeline > li.folder-img:before {
    //     background: url('#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_folder.svg') no-repeat;
      
    //     content: attr(data-date);
    //     display: inline-block;
    //     position: absolute;
    //     border-radius: 50%;
    //    /* border: 2px solid #346CED; */
    //     left: 15px;
    //     width: 30px;
    //     height: 30px;
    //     z-index: 400;

            background: url('#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_folder.svg') no-repeat;
    content: attr(data-date);
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    /* border: 2px solid #346CED; */
    left: 5px;
    width: 30px;
    height: 30px;
    z-index: 400;
    }
    ul.timeline > li.request-img:before {

            background: url('#{$CDNIMAGESBASEURL}/hrspa/Content/Images/ic_requested.svg') no-repeat;
    content: attr(data-date);
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    left: 5px;
    width: 30px;
    height: 30px;
    z-index: 400;
    }
    ul.timeline > li.approved-img:before {

            background: url('#{$CDNIMAGESBASEURL}/hrspa/Content/Images/ic_approved.svg') no-repeat;
    content: attr(data-date);
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    left: 5px;
    width: 30px;
    height: 30px;
    z-index: 400;
    }
    ul.timeline > li.rejected-img:before {

            background: url('#{$CDNIMAGESBASEURL}/hrspa/Content/Images/ic_rejected.svg') no-repeat;
    content: attr(data-date);
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    left: 5px;
    width: 30px;
    height: 30px;
    z-index: 400;
    }
    ul.timeline > li.submitandresubmit-img:before {

            background: url('#{$CDNIMAGESBASEURL}/hrspa/Content/Images/ic_submitnresubmit.svg') no-repeat;
    content: attr(data-date);
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    left: 5px;
    width: 30px;
    height: 30px;
    z-index: 400;
    }
    ul.timeline > li.resendmailandpetition-img:before {

            background: url('#{$CDNIMAGESBASEURL}/hrspa/Content/Images/resend_email&resend_petition.svg') no-repeat;
    content: attr(data-date);
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    left: 5px;
    width: 30px;
    height: 30px;
    z-index: 400;
    }
    ul.timeline > li.canceled-img:before {

            background: url('#{$CDNIMAGESBASEURL}/hrspa/Content/Images/ic_canceledrequest.svg') no-repeat;
    content: attr(data-date);
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    left: 5px;
    width: 30px;
    height: 30px;
    z-index: 400;
    }
    
    ul.timeline > li.share-img:before {
    //     background: url('#{$CDNIMAGESBASEURL}/hrspa/Content/Images/ic_share.svg') no-repeat;
      
    //     content: attr(data-date);
    //     display: inline-block;
    //     position: absolute;
    //     border-radius: 50%;
    //    /* border: 2px solid #346CED; */
    //     left: 15px;
    //     width: 30px;
    //     height: 30px;
    //     z-index: 400;

           background: url('#{$CDNIMAGESBASEURL}/hrspa/Content/Images/ic_share.svg') no-repeat;
    content: attr(data-date);
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    /* border: 2px solid #346CED; */
    left: 5px;
    width: 30px;
    height: 30px;
    z-index: 400;
    }
    ul.timeline > li.delete-img:before {
    //     background: url('#{$CDNIMAGESBASEURL}/hrspa/Content/Images/activity_delete_icon.svg') no-repeat;
      
    //     content: attr(data-date);
    //     display: inline-block;
    //     position: absolute;
    //     border-radius: 50%;
    //    /* border: 2px solid #346CED; */
    //     left: 15px;
    //     width: 30px;
    //     height: 30px;
    //     z-index: 400;

         background: url('#{$CDNIMAGESBASEURL}/hrspa/Content/Images/activity_delete_icon.svg') no-repeat;
    content: attr(data-date);
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    /* border: 2px solid #346CED; */
    left: 5px;
    width: 30px;
    height: 30px;
    z-index: 400;
    }
    ul.timeline > li.saved-img:before {
    //     background: url('#{$CDNIMAGESBASEURL}/hrspa/Content/Images/ic_saved.svg') no-repeat;
      
    //     content: attr(data-date);
    //     display: inline-block;
    //     position: absolute;
    //     border-radius: 50%;
    //    /* border: 2px solid #346CED; */
    //     left: 15px;
    //     width: 30px;
    //     height: 30px;
    //     z-index: 400;

        background: url('#{$CDNIMAGESBASEURL}/hrspaImages/ic_saved.svg') no-repeat;
    content: attr(data-date);
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    /* border: 2px solid #346CED; */
    left: 5px;
    width: 30px;
    height: 30px;
    z-index: 400;
    }
    ul.timeline > li.download-img:before {
    //     background: url('#{$CDNIMAGESBASEURL}/hrspa/Content/Images/Download.svg') no-repeat;
      
    //     content: attr(data-date);
    //     display: inline-block;
    //     position: absolute;
    //     border-radius: 50%;
    //    /* border: 2px solid #346CED; */
    //     left: 5px;
    //     width: 30px;
    //     height: 30px;
    //     z-index: 400;

    background: url('#{$CDNIMAGESBASEURL}/hrspa/Content/Images/activity_download_icon.svg') no-repeat;
    content: attr(data-date);
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    /* border: 2px solid #346CED; */
    left: 5px;
    width: 30px;
    height: 30px;
    z-index: 400;
    }

     ul.HideUiCss > li.upload-img:before {
        background: url('#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_upload.svg') no-repeat;
      
        content: attr(data-date);
        display: inline-block;
        position: absolute;
        border-radius: 50%;
       /* border: 2px solid #346CED; */
        left: 5px;
        width: 30px;
        height: 30px;
        z-index: 400;

        
    }
    ul.HideUiCss > li.update-img:before {
        background: url('#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_update.svg') no-repeat;
      
        content: attr(data-date);
        display: inline-block;
        position: absolute;
        border-radius: 50%;
       /* border: 2px solid #346CED; */
        left: 5px;
        width: 30px;
        height: 30px;
        z-index: 400;
    }
    ul.HideUiCss > li.withdrawal-img:before {
        background: url('#{$CDNIMAGESBASEURL}/hrspa/Content/Images/Withdraw.svg') no-repeat;
      
        content: attr(data-date);
        display: inline-block;
        position: absolute;
        border-radius: 50%;
       /* border: 2px solid #346CED; */
        left: 5px;
        width: 30px;
        height: 30px;
        z-index: 400;
    }
    ul.HideUiCss > li.folder-img:before {
        background: url('#{$CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_folder.svg') no-repeat;
      
        content: attr(data-date);
        display: inline-block;
        position: absolute;
        border-radius: 50%;
       /* border: 2px solid #346CED; */
        left: 5px;
        width: 30px;
        height: 30px;
        z-index: 400;
    }
    ul.HideUiCss > li.request-img:before {
        background: url('#{$CDNIMAGESBASEURL}/hrspa/Content/Images/ic_requested.svg') no-repeat;
      
        content: attr(data-date);
        display: inline-block;
        position: absolute;
        border-radius: 50%;
       /* border: 2px solid #346CED; */
        left: 5px;
        width: 30px;
        height: 30px;
        z-index: 400;
    }
    ul.HideUiCss > li.approved-img:before {
        background: url('#{$CDNIMAGESBASEURL}/hrspa/Content/Images/ic_approved.svg') no-repeat;
      
        content: attr(data-date);
        display: inline-block;
        position: absolute;
        border-radius: 50%;
       /* border: 2px solid #346CED; */
        left: 5px;
        width: 30px;
        height: 30px;
        z-index: 400;
    }
    ul.HideUiCss > li.rejected-img:before {
        background: url('#{$CDNIMAGESBASEURL}/hrspa/Content/Images/ic_rejected.svg') no-repeat;
      
        content: attr(data-date);
        display: inline-block;
        position: absolute;
        border-radius: 50%;
       /* border: 2px solid #346CED; */
        left: 5px;
        width: 30px;
        height: 30px;
        z-index: 400;
    }
    ul.HideUiCss > li.submitandresubmit-img:before {
        background: url('#{$CDNIMAGESBASEURL}/hrspa/Content/Images/ic_submitnresubmit.svg') no-repeat;
      
        content: attr(data-date);
        display: inline-block;
        position: absolute;
        border-radius: 50%;
       /* border: 2px solid #346CED; */
        left: 5px;
        width: 30px;
        height: 30px;
        z-index: 400;
    }
    ul.HideUiCss > li.resendmailandpetition-img:before {
        background: url('#{$CDNIMAGESBASEURL}/hrspa/Content/Images/resend_email&resend_petition.svg') no-repeat;
      
        content: attr(data-date);
        display: inline-block;
        position: absolute;
        border-radius: 50%;
       /* border: 2px solid #346CED; */
        left: 5px;
        width: 30px;
        height: 30px;
        z-index: 400;
    }
    ul.HideUiCss > li.canceled-img:before {
        background: url('#{$CDNIMAGESBASEURL}/hrspa/Content/Images/ic_canceledrequest.svg') no-repeat;
      
        content: attr(data-date);
        display: inline-block;
        position: absolute;
        border-radius: 50%;
       /* border: 2px solid #346CED; */
        left: 5px;
        width: 30px;
        height: 30px;
        z-index: 400;
    }
    ul.HideUiCss > li.share-img:before {
        background: url('#{$CDNIMAGESBASEURL}/hrspa/Content/Images/ic_share.svg') no-repeat;
      
        content: attr(data-date);
        display: inline-block;
        position: absolute;
        border-radius: 50%;
       /* border: 2px solid #346CED; */
        left: 5px;
        width: 30px;
        height: 30px;
        z-index: 400;
    }
    ul.HideUiCss > li.delete-img:before {
        background: url('#{$CDNIMAGESBASEURL}/hrspa/Content/Images/activity_delete_icon.svg') no-repeat;
      
        content: attr(data-date);
        display: inline-block;
        position: absolute;
        border-radius: 50%;
       /* border: 2px solid #346CED; */
        left: 5px;
        width: 30px;
        height: 30px;
        z-index: 400;
    }
    ul.HideUiCss > li.saved-img:before {
        background: url('#{$CDNIMAGESBASEURL}/hrspa/Content/Images/ic_saved.svg') no-repeat;
      
        content: attr(data-date);
        display: inline-block;
        position: absolute;
        border-radius: 50%;
       /* border: 2px solid #346CED; */
        left: 5px;
        width: 30px;
        height: 30px;
        z-index: 400;
    }
    ul.HideUiCss > li.download-img:before {
        background: url('#{$CDNIMAGESBASEURL}/hrspa/Content/Images/activity_download_icon.svg') no-repeat;
      
        content: attr(data-date);
        display: inline-block;
        position: absolute;
        border-radius: 50%;
       /* border: 2px solid #346CED; */
        left: 5px;
        width: 30px;
        height: 30px;
        z-index: 400;
    }
    .upload-img ,.update-img, .folder-img ,.share-img ,.delete-img, .saved-img, .download-img {
      //  padding-bottom: 92px;
    }
    .modal-background{
       // background: rgb(248, 248, 248) !important;
       

    }
    .modal-body{
      position:absolute !important;
    }
    .comments-style{
    background-color: #f3f3f3;
    margin-top: 10px;
    border-radius: 5px;
    padding: 10px;
    font-style: italic;
    word-break: break-word;
    }
    .reject-text-style{
    font-style: italic;
     word-break: break-word;
    }
    .top-div-class{
        margin-bottom:20px
    }
    .date-time-style{
      float: none;
    width: 100px;
    display: inline-block;
    padding-bottom: 0px;
    vertical-align: top;
    }
    .metadatapadding{
        padding: 0 0 5px
    }
    .excess-header {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
        white-space: nowrap;
    }
</style>


// WEBPACK FOOTER //
// src/components/ESSProfile/FormI539/I539Activitylog.vue